import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { HttpResponse } from '@angular/common/http';
import { of, throwError } from 'rxjs';
import Destinations from './mock/destination.json';
import Locations from './mock/location.json';
import Activitys from './mock/activity.json';
import CustomTours from './mock/custom-tours.json';
import Visas from './mock/visa.json';
import Login from './mock/login.json';
import Agents from './mock/manage-agents.json';
import Customers from './mock/manage-customer.json';
import Enquiries from './mock/manage-enquiries.json';

const mockMode: boolean = false;

// @ts-ignore
export const mockInterceptor: HttpInterceptorFn = (req, next) => {
  if (mockMode) {
    if (!localStorage.getItem('login')) {
      localStorage.setItem('login', JSON.stringify(Login));
    }
    if (!localStorage.getItem('destination')) {
      localStorage.setItem('destination', JSON.stringify(Destinations));
    }
    if (!localStorage.getItem('location')) {
      localStorage.setItem('location', JSON.stringify(Locations));
    }
    if (!localStorage.getItem('activity')) {
      localStorage.setItem('activity', JSON.stringify(Activitys));
    }
    if (!localStorage.getItem('custom-tours')) {
      localStorage.setItem('custom-tours', JSON.stringify(CustomTours));
    }
    // if (!localStorage.getItem('visa')) {
    //   localStorage.setItem('visa', JSON.stringify(Visas));
    // }
    // if (!localStorage.getItem('manage-agents')) {
    //   localStorage.setItem('manage-agents', JSON.stringify(Agents));
    // }
    if (!localStorage.getItem('manage-customer')) {
      localStorage.setItem('manage-customer', JSON.stringify(Customers));
    }
    // if (!localStorage.getItem('manage-enquiries')) {
    //   localStorage.setItem('manage-enquiries', JSON.stringify(Enquiries));
    // }
    return of(handleMock(req));
  } else {
    if(req.url.includes('/login')) {
      // @ts-ignore
      const body = { ...req.body };
      if (body.phone) {
        body.email = body.phone;
        delete body.phone;
      }
      const modifiedReq = req.clone({ body });
      return next(modifiedReq);
    }
    return next(req);
  }
};

const handleMock = (req: any) => {
  const localhostVar = req?.url
    ?.split('/')
    ?.filter((act: any) => act?.includes('.php'))?.[0]
    ?.split('?')?.[0]
    ?.replace('.php', '');
  let data = JSON.parse(localStorage.getItem(localhostVar) || '[]');
  let nonFilteredData = JSON.parse(localStorage.getItem(localhostVar) || '[]');
  const payloadData = req.body;
  const loggedInUser = JSON.parse(sessionStorage.getItem('loggedInUser') || '[]');
  if ((!loggedInUser?.role || loggedInUser?.role != 'Admin') && payloadData?.action?.toLowerCase() !== 'agentlogin' && payloadData?.action?.toLowerCase() !== 'customerlogin' && payloadData?.action?.toLowerCase() !== 'login' && !req?.url.includes('list=all')) {
    data = data?.filter((res: any) => res.createdBy == loggedInUser?.id || res.updatedBy == loggedInUser?.id);
  }
  let msg = '';
  let respData = JSON.parse(JSON.stringify(data));
  if (req.method.toLowerCase() == 'post') {
    if (payloadData?.action?.toLowerCase() == 'login') {
      sessionStorage.removeItem('user');
      if (data.length) {
        const loginUser = data.filter(
          (user: any) =>
            user.phone == payloadData.phone &&
            user.password == payloadData.password
        );
        if (loginUser.length) {
          msg = 'Thanks for login';
          sessionStorage.setItem('user', 'admin');
          respData = loginUser[0];
        } else {
          const response = checkMockFailRes(
            req,
            data,
            'Invalid Login credentials'
          );
          return of(response);
        }
      } else {
        const response = checkMockFailRes(
          req,
          data,
          'Invalid Login credentials'
        );
        return of(response);
      }
    } else if (payloadData?.action?.toLowerCase() == 'agentlogin') {
      sessionStorage.removeItem('user');
      if (data.length) {
        const loginUser = data.filter(
          (user: any) =>
            user.username == payloadData.email &&
            user.password == payloadData.password
        );
        if (loginUser.length) {
          msg = 'Thanks for login';
          sessionStorage.setItem('user', 'agent');
          respData = loginUser[0];
        } else {
          const response = checkMockFailRes(
            req,
            data,
            'Invalid Login credentials'
          );
          return of(response);
        }
      } else {
        const response = checkMockFailRes(
          req,
          data,
          'Invalid Login credentials'
        );
        return of(response);
      }
    } else if (payloadData?.action?.toLowerCase() == 'customerlogin') {
      sessionStorage.removeItem('user');
      if (data.length) {
        const loginUser = data.filter(
          (user: any) =>
            user.primary_contact == payloadData.phone &&
            user.password == payloadData.password
        );
        if (loginUser.length) {
          msg = 'Thanks for login';
          sessionStorage.setItem('user', 'customer');
          respData = loginUser[0];
        } else {
          const response = checkMockFailRes(
            req,
            data,
            'Invalid Login credentials'
          );
          return of(response);
        }
      } else {
        const response = checkMockFailRes(
          req,
          data,
          'Invalid Login credentials'
        );
        return of(response);
      }
    } else if (payloadData?.action?.toLowerCase() == 'addenquiry' && sessionStorage.getItem('user') == 'customer') {
      delete payloadData.action;
      payloadData['customer'] = JSON.parse(sessionStorage.getItem('loggedInUser') || '[]')?.['id'];
      payloadData['id'] = new Date().getTime();
      payloadData['isActive'] = 1;
      payloadData['createdBy'] = JSON.parse(sessionStorage.getItem('loggedInUser') || '[]')?.['id'];
      payloadData['createdAt'] = new Date().getTime();
      payloadData['updatedBy'] = null;
      payloadData['updatedAt'] = null;
      payloadData['deletedBy'] = null;
      payloadData['deletedAt'] = null;
      payloadData['deletedReason'] = null;
      nonFilteredData.push(payloadData);
      respData = JSON.parse(JSON.stringify(nonFilteredData));
    } else {
      delete payloadData.action;
      payloadData['id'] = new Date().getTime();
      payloadData['isActive'] = 1;
      payloadData['createdBy'] = JSON.parse(
        sessionStorage.getItem('loggedInUser') || '[]'
      )?.id;
      payloadData['createdAt'] = new Date().getTime();
      payloadData['updatedBy'] = null;
      payloadData['updatedAt'] = null;
      payloadData['deletedBy'] = null;
      payloadData['deletedAt'] = null;
      payloadData['deletedReason'] = null;
      nonFilteredData.push(payloadData);
      respData = JSON.parse(JSON.stringify(nonFilteredData));
    }
  } else if (req.method.toLowerCase() == 'put') {
    if (req?.body?.action.includes('update')) {
      payloadData['updatedBy'] = JSON.parse(
        sessionStorage.getItem('loggedInUser') || '[]'
      )?.id;
      payloadData['updatedAt'] = new Date().getTime();
      const index = nonFilteredData.findIndex((dat: any) => dat.id == payloadData.id);
      if (index !== -1) {
        nonFilteredData[index] = payloadData;
      }
      data = JSON.parse(JSON.stringify(nonFilteredData));
    } else if (req?.body?.action.includes('delete')) {
      payloadData['deletedBy'] = JSON.parse(
        sessionStorage.getItem('loggedInUser') || '[]'
      )?.id;
      payloadData['deletedAt'] = new Date().getTime();
      data.forEach((dat: any) => {
        if (dat.id == payloadData.id) {
          dat['isActive'] = 0;
        }
      });
    }
    respData = JSON.parse(JSON.stringify(data));
  }
  if (req.method.toLowerCase() !== 'get' && req.body.action !== 'login' && req.body.action !== 'agentLogin' && req.body.action !== 'customerLogin') {
    localStorage.setItem(localhostVar, JSON.stringify(respData));
  }
  if (req.method.toLowerCase() == 'get') {
    respData = respData.filter((res: any) => res.isActive != 0);
  }
  return checkMockSuccessRes(req, respData, msg);
};

const checkMockSuccessRes = (req: any, payload: any, msg: string = '') => {
  const mockToken = 'mock-token-abc123';
  const response = new HttpResponse({
    status: 200,
    body: {
      status: true,
      code: 200,
      message: msg,
      data: payload,
      token: mockToken,
    },
    headers: req.headers.set('Authorization', `Bearer ${mockToken}`),
  });
  return response;
};

const checkMockFailRes = (req: any, payload: any, msg: string = '') => {
  const mockToken = 'mock-token-abc123';
  // const response = new HttpResponse({
  //   status: 400,
  //   body: {
  //     status: false,
  //     code: 400,
  //     message: msg,
  //     data: payload,
  //     token: mockToken,
  //   },
  //   headers: req.headers.set('Authorization', `Bearer ${mockToken}`),
  // });
  return throwError(() =>
    new HttpErrorResponse({
      status: 400,
      statusText: msg,
      url: req.url,
      error: { 
        message: msg,
        data: payload,
        token: mockToken,
      }
    })
  );
};
